export default __webpack_public_path__ + "static/media/dekstop.c90bc599.png";